import React, {useEffect, useState} from 'react';
import './Review.css';
import PocketBase from 'pocketbase';
import { Primary } from '../Constants/Colours';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle,faXmark,faStar } from '@fortawesome/free-solid-svg-icons'
import UnfilledStar from "../GlobalComponents/UnfilledStar";
import InvLogo from '../GlobalComponents/BlurredLogo';
import { motion, AnimatePresence } from 'framer-motion';


function Review({id = ''}) {
    const [review,setReview] = useState()
    const [customer,setCustomer] = useState()
    const [fetching,setFetching] = useState(true)
    const [starAmount, setStarAmount] = useState();
    const [reviewText, setReviewText] = useState();
    const [reviewSubmitted, setReviewSubmitted] = useState(false);
    const [givenConsent, setGivenConsent] = useState(true);
    const [submittingReview, setSubmittingReview] = useState(false);
    const [thankYou, setThankYou] = useState(false);
    const [starColour,setStarColour] = useState(Primary)
    const pb = new PocketBase('https://admin.aaatheatingandgas.co.uk/aaatbase')
    pb.autoCancellation(false)

    
    
    const fetchReview = async () => {
        const rev = await pb.collection('Reviews').getOne(id)
        setReview(rev)
        setReviewSubmitted(rev.Submitted || false)
        setThankYou(rev.Submitted || false)
        setReviewText(rev.Review || '')
        setStarAmount(rev.Stars || 0)
        const cust = await pb.collection('Customers').getOne(rev.Customer)
        setCustomer(cust)
        setFetching(false)
    }

    const SubmitReview = async () => {
        if (reviewText == '' || starAmount == 0) {
            document.querySelector('.Review-Input').style.borderColor = 'red';
            setStarColour('red')
            setStarAmount(0)
            return;
        }
        setSubmittingReview(true)
        const reviewData = {
          'Stars': starAmount,
          'Review': reviewText,
          'Submitted': true,
          'Submission_Date': new Date().toUTCString()
        }
        const newreview = await pb.collection('Reviews').update(review.id,reviewData)
        let customerReviews = customer.Reviews
        customerReviews.push(newreview.id)
        await pb.collection('Customers').update(customer.id, {Reviews: customerReviews})
        setReviewSubmitted(true)
        setSubmittingReview(false)
        setTimeout(()=> {
            setThankYou(true)
        },2000)
      }



    useEffect(() => {
        fetchReview()
    },[])

    

    const animationVariants = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0, transition: { duration: 3 } },
        exit: { opacity: 0, y: -20, transition: { duration: 1.5 } }
    };

    return (
        <>
        <AnimatePresence>
            {!fetching && !reviewSubmitted && (
                <motion.div
                    className="Review"
                    variants={animationVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                >
                    <h3>{(() => {
                        const hour = new Date().getHours();
                        if (hour >= 5 && hour < 12) return 'Good morning';
                        if (hour >= 12 && hour < 17) return 'Good afternoon';
                        return 'Good evening';
                    })()} {customer.Name},</h3>
                    <h4>AAAT Heating and Gas sincerely appreciates you taking the time to share your experience. 
                        </h4>
                        <h5>Please rate your overall experience</h5>
                        <div className="Star-Container">
                    { starAmount >= 1 ? <FontAwesomeIcon onClick={() => setStarAmount(1)} size="2x" color={Primary} icon={faStar}/> : <UnfilledStar onClick={() => setStarAmount(1)} size="2x" colour={starColour}/>}
                    { starAmount >= 2 ? <FontAwesomeIcon onClick={() => setStarAmount(2)} size="2x" color={Primary} icon={faStar}/> : <UnfilledStar onClick={() => setStarAmount(2)} size="2x" colour={starColour}/>}
                    { starAmount >= 3 ? <FontAwesomeIcon onClick={() => setStarAmount(3)} size="2x" color={Primary} icon={faStar}/> : <UnfilledStar onClick={() => setStarAmount(3)} size="2x" colour={starColour}/>}
                    { starAmount >= 4 ? <FontAwesomeIcon onClick={() => setStarAmount(4)} size="2x" color={Primary} icon={faStar}/> : <UnfilledStar onClick={() => setStarAmount(4)} size="2x" colour={starColour}/>}
                    { starAmount >= 5 ? <FontAwesomeIcon onClick={() => setStarAmount(5)} size="2x" color={Primary} icon={faStar}/> : <UnfilledStar onClick={() => setStarAmount(5)} size="2x" colour={starColour}/>}
                  </div>
                  <textarea maxLength="200" onChange={(e) => setReviewText(e.target.value)} placeholder='Rate out of 5 Stars Above & Write your Review Here' className='Review-Input'/>
                  <div className="Consent-Row">
                  <motion.div whileTap={{scale:0.9}} whileHover={{scale:1.1}} onClick={givenConsent ? () => setGivenConsent(false):() => setGivenConsent(true)} className="Consent-Box">
                    {givenConsent && (<InvLogo size={0.35} color={Primary}/>)}
                  </motion.div>
                  <p>
                    By checking this box, I agree to have my review processed and shared 
                    as outlined in the <a href='https://admin.aaatheatingandgas.co.uk/aaatbase/api/files/izr0f34n2zqt46q/i5oiutibu5g947x/aaat_heating_and_gas_services_privacy_policy_Ov167fZMuB.pdf' download='aaat_heating_and_gas_services_privacy_policy.pdf' >Privacy Policy</a>. I understand that my feedback 
                    may be visible to others and can help future customers. I can withdraw 
                    my consent at any time.
                    </p>
                </div>
                  <motion.button style={{color:givenConsent ? '#0e52f0cc' : '#d7d7d8cc'}} disabled={submittingReview} onClick={SubmitReview} whileTap={{scale:0.8}}className="Review-Submit">Submit Review</motion.button>
                </motion.div>
            )}
        </AnimatePresence>
        <AnimatePresence>
            {!fetching && thankYou && (
                <motion.div
                    className="Review"
                    variants={animationVariants}
                    initial="initial"
                    animate="animate"
                    exit="exit"
                >
                    <FontAwesomeIcon onClick={() => setStarAmount(5)} style={{padding:'5%'}} size="4x" color={Primary} icon={faCheckCircle}/>
                    <h3 style={{textAlign:'center'}}>Thank you {customer.Name}</h3>
                    <h4 style={{textAlign:'center'}}>Your feedback is highly valued and sincerely appreciated</h4>
                      
                        <div className="Star-Container">
                    { starAmount >= 1 ? <FontAwesomeIcon onClick={() => setStarAmount(1)} size="2x" color={Primary} icon={faStar}/> : ''}
                    { starAmount >= 2 ? <FontAwesomeIcon onClick={() => setStarAmount(2)} size="2x" color={Primary} icon={faStar}/> : ''}
                    { starAmount >= 3 ? <FontAwesomeIcon onClick={() => setStarAmount(3)} size="2x" color={Primary} icon={faStar}/> : ''}
                    { starAmount >= 4 ? <FontAwesomeIcon onClick={() => setStarAmount(4)} size="2x" color={Primary} icon={faStar}/> : ''}
                    { starAmount >= 5 ? <FontAwesomeIcon onClick={() => setStarAmount(5)} size="2x" color={Primary} icon={faStar}/> : ''}
                  </div>
                  <h5 className='Commas' style={{textAlign:'left',width:'80%'}}>"</h5>
                  <p className='Review-Text'>{reviewText}</p>
                  <h5 className='Commas' style={{textAlign:'right',width:'80%'}}>"</h5>

                  <motion.a whileTap={{scale:0.9}} whileHover={{scale:1.1}} href="https://aaatheatingandgas.co.uk" style={{textDecoration:'none'}}  className="Review-Home">Home</motion.a>

                </motion.div>
            )}
        </AnimatePresence>
        </>
    );
}

export default Review;
